import { useState } from 'react';
import './LoginWindow.scss';
import Helper from '../../shared/common.helper';
import { ArrowRight16 } from '@carbon/icons-react';
import {
  Button,
  Link,
  Checkbox,
  FormLabel,
  TextInput,
} from 'carbon-components-react';

const LoginComponent = (props) => {
  /**
   * on click login button
   */
  const onClickLoginUrl = () => {
    const siteUrl = Helper.getQueryVariable(props.loginURL, 'state');
    console.log('siteUrl===========', siteUrl);
    console.log(' props.loginURL=========', props.loginURL);
    console.log('props.pageUrl==================', props.pageUrl);
    if (siteUrl) {
      Helper.redirect(
        props.loginURL.replace(siteUrl, encodeURIComponent(props.pageUrl)),
      );
    }
  };

  const [isAuthorizeAgentChecked, setAuthorizeAgentChecked] = useState(false);
  const [DsrForm, setDsrForm] = useState({
    userEmailAddress: props.userEmailAddress ? props.userEmailAddress : '',
    subjectEmail: props.subjectEmail ? props.subjectEmail : '',
    authorisedEmail: props.authorisedEmail ? props.authorisedEmail : '',
    isFrom: props.isFrom ? props.isFrom : '',
  });

  /**
   * On click authorized agent
   */
  const onclickAuthorizedAgent = (e) => {
    if (e === false) {
      setDsrForm({
        ...DsrForm,
        email: '',
        subjectEmail: '',
        authorisedEmail: '',
        isFrom: '',
      });
    } else {
      setDsrForm({
        ...DsrForm,
        isFrom: 'authorised',
      });
    }
    setAuthorizeAgentChecked(isAuthorizeAgentChecked ? false : true);
  };

  const onSubmitDSRModelForm = (e) => {
    e.preventDefault();
    props.onSubmitDSRModelForm({
      data: DsrForm,
    });
  };

  const onSubmitotpEmail = (e) => {
    e.preventDefault();
    props.onSubmitotpEmail({
      data: DsrForm,
    });
  };

  const validateEmailForm = () => {
    return (DsrForm.userEmailAddress.length === 0 ||
      !Helper.validateEmail(DsrForm.userEmailAddress)) &&
      (DsrForm.authorisedEmail.length === 0 ||
        !Helper.validateEmail(DsrForm.authorisedEmail) ||
        DsrForm.subjectEmail.length === 0 ||
        !Helper.validateEmail(DsrForm.subjectEmail))
      ? true
      : false;
  };

  return (
    <div className="loginForm">
      <div className="bx--grid">
        <div className="bx--row">
          <div className="bx--col-sm-4 bx--col-lg-16">
            <div className="loginDiv">
              <br />
              <div className="bx--row">
                <div className="bx--col-lg-6 bx--space loginTop">
                  {props.isFrom === '' && (
                    <header className="loginHeader">
                      <h3>{props.t.dsr.title}</h3>
                    </header>
                  )}
                  {props.isFrom === 'dsrstatus' && (
                    <header className="loginHeader">
                      <h3>{props.t.dsr_status.title}</h3>
                    </header>
                  )}
                  <br />
                  <hr></hr>
                  <br />
                  <form method="post" onSubmit={(e) => onSubmitDSRModelForm(e)}>
                    <FormLabel>
                      <span className="ibmIdfont">
                        {props.t.login.loginwithIBMid}
                      </span>
                    </FormLabel>
                    <br />
                    <br />
                    <Button
                      className="loginButton"
                      onClick={() => onClickLoginUrl()}
                      onChange={(e) => {
                        setDsrForm({
                          ...DsrForm,
                          email: e.target.value,
                          loginwindow: 1,
                        });
                      }}
                      value={DsrForm.email}
                    >
                      {props.t.login.ContButton}
                      <ArrowRight16 aria-label="Arrow Right" />
                    </Button>
                  </form>
                  <br></br>
                  <br />
                  <span>{props.t.login.or}</span>
                  <br />
                  <br />
                  <FormLabel>
                    <span className="labelStyle">
                      {props.t.login.contwithEmail}
                    </span>
                  </FormLabel>
                  {((props.isFrom === '' && props.isFrom === 'dsr') ||
                    DsrForm.isFrom != 'authorised' ||
                    props.isFrom === 'dsrstatus') && (
                    <div className="loginDiv1">
                      <TextInput
                        tabIndex={0}
                        labelText={props.t.login.email}
                        autoComplete="off"
                        id="userEmailAddress"
                        placeholder={props.t.login.emailPlaceholder}
                        onChange={(e) => {
                          setDsrForm({
                            ...DsrForm,
                            userEmailAddress: e.target.value,
                            isFrom: 'dsr',
                          });
                        }}
                        invalid={
                          !DsrForm.userEmailAddress.length === 0 ||
                          !Helper.validateEmail(DsrForm.userEmailAddress)
                            ? true
                            : false
                        }
                        value={DsrForm.userEmailAddress}
                        onKeyDown={(e) => Helper.keypressAvoidSpace(e)}
                        required
                      />
                    </div>
                  )}
                  {(DsrForm.isFrom === 'authorised' ||
                    isAuthorizeAgentChecked) && (
                    <div className="loginDiv1">
                      <TextInput
                        tabIndex={0}
                        labelText="Email of data subject"
                        autoComplete="off"
                        id="subjectemail"
                        placeholder={props.t.login.emailPlaceholder}
                        onChange={(e) => {
                          setDsrForm({
                            ...DsrForm,
                            subjectEmail: e.target.value,
                            isFrom: 'authorised',
                          });
                        }}
                        invalid={
                          !DsrForm.subjectEmail.length === 0 ||
                          !Helper.validateEmail(DsrForm.subjectEmail)
                            ? true
                            : false
                        }
                        value={DsrForm.subjectEmail}
                        onKeyDown={(e) => Helper.keypressAvoidSpace(e)}
                        required
                      />
                    </div>
                  )}
                  <br />
                  {props.isFrom !== 'dsrstatus' && (
                    <Checkbox
                      labelText={props.t.login.loginbuttonSubtext1}
                      id="loginCheckbox"
                      checked={isAuthorizeAgentChecked}
                      onChange={(e) => {
                        onclickAuthorizedAgent(e);
                      }}
                    />
                  )}
                  <br />
                  {(DsrForm.isFrom === 'authorised' ||
                    isAuthorizeAgentChecked) && (
                    <div className="loginDiv1">
                      <TextInput
                        tabIndex={0}
                        labelText={props.t.login.authorisedEmail}
                        autoComplete="off"
                        id="authorisedEmail"
                        placeholder={props.t.login.emailPlaceholder}
                        onChange={(e) => {
                          setDsrForm({
                            ...DsrForm,
                            authorisedEmail: e.target.value,
                            isFrom: 'authorised',
                          });
                        }}
                        invalid={
                          !DsrForm.authorisedEmail.length === 0 ||
                          !Helper.validateEmail(DsrForm.authorisedEmail)
                            ? true
                            : false
                        }
                        value={DsrForm.authorisedEmail}
                        onKeyDown={(e) => Helper.keypressAvoidSpace(e)}
                        required
                      />
                    </div>
                  )}
                  <br />
                  <Button
                    onClick={(e) => onSubmitotpEmail(e)}
                    kind="tertiary"
                    disabled={validateEmailForm()}
                    className="loginButton"
                  >
                    {props.t.login.ContButton}
                    <ArrowRight16 aria-label="Arrow Right" />
                  </Button>
                  <br />
                  <br />
                  <hr />
                  <p className="loginNote">
                    {props.t.login.loginNote1} <br />
                    <Link href="https://www.ibm.com/us-en/privacy">
                      {props.t.login.loginNotelink}
                    </Link>
                  </p>
                </div>
                <div className="bx--col-lg-10 bx--space loginNoteBottom">
                  <img
                    src="https://www.ibm.com/privacy/requests/login1.png"
                    alt="login page lock icon"
                    width="100%"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default LoginComponent;
